<template>
  <div>
    <div v-if="$auth.policies['view-meal-config']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <Breadcrumbs
          headline="Nhóm đăng ký ăn"
          :link="[{ text: 'Dịch vụ bếp', href: '#' }, { text: 'Nhóm đăng ký ăn' }]"
        />
        <v-btn depressed dark color="#0D47A1" @click="openCreate">
          <v-icon left>add</v-icon>Thêm nhóm
        </v-btn>
      </div>

      <v-card outlined class="pa-4 mx-4 mb-4 elevation-0">
        <v-row>
          <v-col cols="12" md="5">
            <v-text-field
              v-model="search"
              label="Tìm theo tên nhóm"
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="refresh"
              @click:clear="refresh"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="category"
              :items="categoryOptions"
              label="Phân loại"
              outlined
              dense
              clearable
              hide-details
              @change="refresh"
            />
          </v-col>
          <v-col cols="12" md="3" class="d-flex align-center">
            <v-btn color="primary" depressed @click="refresh"><v-icon left>search</v-icon>Tìm kiếm</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card outlined class="mx-4 elevation-0">
        <v-data-table
          :headers="headers"
          :items="groups"
          :loading="loading"
          :server-items-length="totalItems"
          :options.sync="options"
          :footer-props="{ 'items-per-page-options': [10, 20, 50] }"
        >
          <template v-slot:[`item.category`]="{ item }">
            {{ groupCategoryLabel(item.category) }}
          </template>
          <template v-slot:[`item.defaultType`]="{ item }">
            {{ defaultTypeLabel(item) }}
          </template>
          <template v-slot:[`item.amount`]="{ item }">{{ item.amount != null ? item.amount : EMPTY_LABEL }}</template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn icon small color="primary" title="Chi tiết" :to="`/meal-group-detail/${item.id}`">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <!-- Dialog tạo / sửa nhóm custom -->
      <v-dialog v-model="dialog" width="480" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card>
          <v-card-title class="primary white--text">
            <span>THÊM NHÓM MỚI</span>
            <v-spacer />
            <v-icon color="white" @click="dialog = false">close</v-icon>
          </v-card-title>
          <v-form ref="form" class="pa-4" @keydown.native.enter.prevent="save">
            <v-text-field
              v-model="form.title"
              label="Tên nhóm đối tượng"
              outlined
              dense
              :rules="[$rules.required]"
            />
          </v-form>
          <v-card-actions>
            <v-btn outlined @click="dialog = false">Hủy</v-btn>
            <v-spacer />
            <v-btn color="primary" depressed :loading="saving" @click="save">Lưu</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <Page403 v-else />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import Page403 from '@/views/Page403.vue'
import {
  GROUP_CATEGORY_OPTIONS,
  DEFAULT_TYPE_LABEL,
  EMPTY_LABEL,
  groupCategoryLabel
} from '@/modules/mealConfig/mealConfigConstants'
import { mapActions, mapState } from 'vuex'

export default {
  components: { Breadcrumbs, Page403 },
  data() {
    return {
      search: '',
      category: null,
      categoryOptions: GROUP_CATEGORY_OPTIONS,
      EMPTY_LABEL,
      options: {},
      dialog: false,
      saving: false,
      form: { title: '' },
      headers: [
        { text: 'Tên nhóm', value: 'title' },
        { text: 'Phân loại', value: 'category' },
        { text: 'Loại mặc định', value: 'defaultType', sortable: false },
        { text: 'Số học sinh', value: 'amount', sortable: false },
        { text: 'Thao tác', value: 'action', sortable: false, align: 'center' }
      ]
    }
  },
  computed: {
    ...mapState('mealGroup', ['groups', 'totalItems', 'loading'])
  },
  watch: {
    options: {
      handler() {
        this.refresh()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('mealGroup', ['fetchList', 'create']),
    groupCategoryLabel,
    defaultTypeLabel(item) {
      if (item.category !== 'default') return EMPTY_LABEL
      return DEFAULT_TYPE_LABEL[item.defaultType] || EMPTY_LABEL
    },
    async refresh() {
      const { page, itemsPerPage } = this.options
      const query = {}
      if (this.search) query.title_contains = this.search
      if (this.category) query.category = this.category
      try {
        await this.fetchList({ page: page || 1, itemsPerPage, ...query })
      } catch (e) {
        this.$alert.error('Không tải được danh sách nhóm: ' + e)
      }
    },
    openCreate() {
      this.form = { title: '' }
      this.dialog = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation())
    },
    async save() {
      if (!this.$refs.form.validate()) return
      this.saving = true
      try {
        const title = this.form.title.trim()
        await this.create({ title, category: 'custom' })
        this.$alert.addSuccess()
        this.dialog = false
        // đổ tên nhóm vừa tạo vào ô search + bỏ lọc category → hiện đúng kết quả nhóm đó
        this.search = title
        this.category = null
        if (this.options.page === 1) this.refresh()
        else this.options.page = 1 // đổi page → watcher options tự refresh
      } catch (err) {
        this.$alert.error('Lưu nhóm thất bại: ' + err)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
